$(document).ready(function(){
  $('.product-main-image').click(function(){
    $(this).toggleClass('zoom-active');
  });
});

$(document).ready(function(){
  $('.image-list-item').zoom({ on:'click' });
});

$(document).ready(function(){
  $('.product-main-image .image-list-item').on('click', function(){
    $(this).find('.zoomImg').toggleClass('changeHeight');
    var orginalHeight = $(this).find('.devEE_originalImg').height();
    $('.changeHeight').css('height', orginalHeight + 200);
    $(this).parents('.container.wide').siblings().find('.zoomImg').removeClass('changeHeight');
  });
});